import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import paths from './../config/paths.json'
import NewRequest from "./newRequest";
import { useContext } from "react";
import DashboardContext from "../contexts/dashboardContext";
import History from "./history";

export default function Home() {
    const navigate = useNavigate();
    const dContext = useContext(DashboardContext)

    var [refresh, setRefresh] = useState(false);
    var onExpertReceiptsPress = () => {
        navigate(paths.expertReceipts)
    }

    return (
        <div className="row m-0 p-0  " >
            <div className="col-12 col-md-6 col-lg-7  col-xl-8 position-fixed  overflow-auto hideScrollBar" style={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                <NewRequest refreshPage={() => { setRefresh(!refresh) }} />
            </div>

            {
                dContext.isMobile ?
                    <></> :
                    <div className=" col-6 col-lg-5 col-xl-4 me-auto overflow-hidden" style={{ top: 0, right: 0, bottom: 0, left: 0 }}>
                        <History showFilter={false} />
                    </div>
            }

        </div>
    )
}